import { createApp } from "vue";
import { createHead } from "@vueuse/head";
import "./style.css";
import App from "./App.vue";
import AOS from "aos";
import "aos/dist/aos.css";

// Create head instance for SEO management
const head = createHead();
const app = createApp(App);

// Use the head plugin
app.use(head);

app.mount("#app");

// Initialize AOS
AOS.init({
  duration: 800,
  easing: "ease-out-cubic",
  once: true,
  offset: 100,
  delay: 100,
});

// Override AOS animations for mobile
function updateAOSForMobile() {
  const isMobile = window.innerWidth < 768; // md breakpoint

  if (isMobile) {
    // Get all timeline cards
    const timelineCards = document.querySelectorAll('[data-aos="fade-right"]');
    timelineCards.forEach((card) => {
      card.setAttribute("data-aos", "fade-left");
    });

    // Refresh AOS to apply changes
    AOS.refresh();
  }
}

// Run on load and resize
window.addEventListener("load", updateAOSForMobile);
window.addEventListener("resize", updateAOSForMobile);
